<div class="mdiv scrollable-element text-grey">
  <div class="main-left w-70 h-100 p-3">
    <div *ngIf="configureLogInPage"
         [innerHTML]="sanitizer.bypassSecurityTrustHtml(title)"
         class="hide-scrollbar"></div>
    <img src="../../../assets/images/syncious/hpc_infra.png"
         alt="img"
         class="img" />
  </div>
  <div class="loginScreen hide-scrollbar"
       [ngStyle]="configureLogInPage ? { height: '86vh' } : { padding: '15vh 0' }">
    <div class="main-container">
      <div *ngIf="!configureLogInPage"
           class="headLogo hide-scrollbar"
           style="display: inline-flex">
        <img *ngIf="!isClientLogin"
             src="../../../assets/images/syncious/synchpc_logo.png"
             style="height: 48px; width: 56px; margin-top: -43px" />
        <span style="
            font-size: 2.1rem;
            font-weight: 700;
            margin: 5px;
            color: var(--s-primary-color);
            margin-top: -38px;
          ">{{ isClientLogin ? "SyncHPC Access" : "SyncHPC" }}</span>
      </div>
      <div *ngIf="configureLogInPage"
           [innerHTML]="sanitizer.bypassSecurityTrustHtml(logoAndTitle)"
           class="hide-scrollbar"></div>
      <br />

      <!-- Admin Login Toggle (only show for non-default auth types) -->
      <div *ngIf="!isDefaultAuthType" style="text-align: center; margin-bottom: 15px;">
        <button type="button"
                mat-button
                (click)="toggleAdminLogin()"
                style="color: var(--s-primary-color); text-decoration: underline; font-size: 0.9rem;">
          {{ showAdminLogin ? 'Use SSO Login' : 'Login as Admin' }}
        </button>
      </div>

      <!-- Username/Password Form (show for default auth types OR when admin login is enabled) -->
      <form *ngIf="shouldShowLoginForm()"
            [formGroup]="loginForm"
            class="loginForm hide-scrollbar"
            (ngSubmit)="onSubmit()"
            autocomplete="off"
            spellcheck="false"
            style="margin-left: 52px">
        <mat-form-field appearance="outline" class="w-90">
          <mat-label>Enter Username</mat-label>
          <input matInput
                 formControlName="loginUsername"
                 style="font-size: 90%"
                 tabindex="0"
                 autofocus />
          <mat-icon matSuffix
                    class="bi bi-person-fill classPassIcon"></mat-icon>
          <mat-error *ngIf="
              loginForm.get('loginUsername').touched &&
              loginForm.get('loginUsername').errors?.required
            ">Username Required*</mat-error>
          <mat-error *ngIf="
              loginForm.get('loginUsername').touched &&
              loginForm.get('loginUsername').errors?.pattern
            ">Username must contain only lowercase letters.</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-90">
          <mat-label>Enter Password</mat-label>
          <input matInput
                 [type]="!fieldTextType ? 'text' : 'password'"
                 formControlName="loginPassword"
                 style="font-size: 90%" />
          <mat-icon *ngIf="loginForm.get('loginPassword').value != (null || '')"
                    (click)="togglePassswordIcon()"
                    matSuffix
                    class="bi classPassIcon"
                    [ngClass]="{
              'bi-eye-fill': fieldTextType,
              'bi-eye-slash-fill': !fieldTextType
            }"></mat-icon>
          <mat-error *ngIf="
              loginForm.get('loginPassword').touched &&
              loginForm.get('loginPassword').errors?.required
            ">Password Required*</mat-error>
        </mat-form-field>
        <mat-error *ngIf="loginForm.errors?.invalidError"
                   style="text-align: center">{{ errorMsg }}</mat-error>
        <div class="submitButton w-90">
          <button mat-raised-button
                  [disabled]="isLoggingIn"
                  id="btn"
                  (click)="onSubmit()">
            {{ showAdminLogin ? 'Login as Admin' : 'Login' }}
          </button>
        </div>
      </form>

      <!-- SSO Login Button (show for non-default auth types when admin login is not enabled) -->
      <ng-container *ngIf="shouldShowSSOButton()" class="submitButton">
        <button mat-raised-button
                class="w-100"
                id="btn"
                [disabled]="isLoggingIn"
                style="background-color: var(--s-primary-color); color: white; margin: 0 auto; display: block; width: 90%;"
                (click)="onSubmit()">
          Login with SSO
        </button>
      </ng-container>

      <!-- Admin Login Notice (show when admin login is active) -->
      <div *ngIf="showAdminLogin" style="text-align: center; margin-top: 10px;">
        <small style="color: #666; font-style: italic;">
          Using admin credentials to bypass SSO authentication
        </small>
      </div>
    </div>
    <img class="syncSpinImg hide-scrollbar"
         *ngIf="isLoggingIn"
         src="./assets/images/syncious/synchpc_logo.png"
         height="45px"
         width="55px"
         alt="" />
  </div>
</div>
